import React from 'react';
import Socials from '../ui/Socials';

export default function Footer () {
  return (
    <footer className='footer'>
    <Socials/>
    <p className='footer__copyright'>© 2026 Dehayez</p>
  </footer>
  )
}